import StoredLayout from '../../layouts/StoredLayout'
import DefaultTables from './DefaultTables'
export default StoredLayout(DefaultTables)



// WEBPACK FOOTER //
// ./src/tables/default-tables/index.js